var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAlarmSilence(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 5.5C12.75 4.94772 13.1977 4.5 13.75 4.5C14.3023 4.5 14.75 4.94772 14.75 5.5V6.08719C15.8745 6.28486 16.9228 6.81333 17.7473 7.61771C18.8134 8.65779 19.4186 10.0756 19.4186 11.5613V16.6242C19.4186 16.9972 19.5702 17.362 19.8513 17.6362C20.1586 17.936 20.4257 18.0711 20.8058 18.0711C21.0511 18.0711 21.25 18.2791 21.25 18.5356C21.25 18.7921 21.0511 19 20.8058 19H6.69423C6.44889 19 6.25 18.7921 6.25 18.5356C6.25 18.2791 6.44889 18.0711 6.69423 18.0711C7.07426 18.0711 7.34131 17.936 7.64867 17.6362C7.92975 17.362 8.08133 16.9972 8.08133 16.6242V11.5613C8.08133 10.0756 8.68659 8.65779 9.75269 7.61771C10.5772 6.81332 11.6255 6.28485 12.75 6.08718V5.5ZM12.25 20.75C11.8358 20.75 11.5 21.0858 11.5 21.5C11.5 21.9142 11.8358 22.25 12.25 22.25H15.25C15.6642 22.25 16 21.9142 16 21.5C16 21.0858 15.6642 20.75 15.25 20.75H12.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 22.25L22 6.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeDasharray: "2 3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 22.25L6 6.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeDasharray: "2 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlarmSilence);
export default __webpack_public_path__ + "static/media/ic-alarm-silence.4e2b4ec10301cdc764f0115d9eeff7fd.svg";
export { ForwardRef as ReactComponent };